import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCompanyData } from '../contexts/DataContext';
import getGroups from 'src/api/services/groups/getGroups';
import getSchedule from 'src/api/services/schedule/getSchedule';
import getReviews from 'src/api/services/reviews/getReviews';
import getVideo from 'src/api/services/videos/getVideo';
import getPhotos from 'src/api/services/photos/getPhotos';

const useServiceDetails = () => {
  const { data } = useCompanyData();
  const [groups, setGroups] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [schedule,setSchedule] = useState({});
  const [videoEmbedSrc, setVideoEmbedSrc] = useState([]);
  const [photos, setPhotos] = useState([]);
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const { t } = data;

  useEffect(() => {
    const fetchGroups = async (serviceId) => {
      const groups = await getGroups(serviceId);
      setGroups(groups);
    };
    const fetchSchedule = async (serviceId) => {
      const schedule = await getSchedule(serviceId);
      setSchedule(schedule);
    };
    const fetchReviews = async (serviceId) => {
      const reviews = await getReviews(serviceId,'serviceId');
      setReviews(reviews);
    };
    const fetchVideos = async (serviceId) => {
      const video = await getVideo(serviceId);
      var array = [];
      for(var i in video) {
        if(getYoutubeId(video[i]?.videoPath)){
          var videoId = getYoutubeId(video[i]?.videoPath);
          var embedSrc = videoId && `https://www.youtube.com/embed/${videoId}`;
          array.push(embedSrc);
        }
      }
      setVideoEmbedSrc(array);
    };
    const fetchPhotos = async (serviceId) => {
      const photos = await getPhotos(serviceId);
      setPhotos(photos);
    };

    fetchGroups(serviceId);
    fetchSchedule(serviceId);
    fetchReviews(serviceId);
    fetchVideos(serviceId);
    fetchPhotos(serviceId);
  }, [serviceId]);

  const handleBooking = (groupId) => {
    const companyId = data?.companyData?.id;
    companyId && navigate(`/booking/${companyId}/${groupId}`);
  };

  const service = data.products?.find((item) => item.id === serviceId);
  return { service, schedule, groups, reviews, videoEmbedSrc, photos, handleBooking, t };
};

function getYoutubeId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return (match && match[2].length === 11)
    ? match[2]
    : null;
};

export default useServiceDetails;
